var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{class:("border-t-" + _vm.weight + " border-" + _vm.color + " mx-auto " + _vm.maxWidthClass)})}
var staticRenderFns = []

export { render, staticRenderFns }